$ ->
  if typeof $ == 'undefined'
    $ = jQuery

  if $("#slide-home-banners").find("li").length > 3
    $("#slide-home-banners").jcarousel
      vertical: false,
      animation: 5000,
      scroll: 3,
      auto: 2,
      wrap: "circular"

  # fix footer height
  h_footer = $("#footer").parents(".container").height()
  $("#footer").parents(".container").parents(".inner-container").css({paddingBottom: "#{h_footer}px"})

  reverseZindex('#box_contact_us > div,.in_container > div,#content > div,.xoxo > li')

  toggle_default_text('.search_input,#comment')

  clickableBox('#games-bar-horizontal li,#games-bar-vertical li,#matches-bar-horizontal li,#matches-bar-vertical li')

  $("form.search_box").submit (e)->
    removeDefaultValueOnSubmit(@)

  slideshow()

  games_bar_horizontal = $('#games-bar-horizontal')
  if games_bar_horizontal.length > 0
    jCarouselAutoInit(games_bar_horizontal, {
      vertical: false,
      animation: 500,
      scroll: 1
    });

  matches_bar_horizontal = $('#matches-bar-horizontal')
  if matches_bar_horizontal.length > 0
    jCarouselAutoInit(matches_bar_horizontal, {
      vertical: false,
      animation: 500,
      scroll: 1
    });

  games_bar_vertical = $('#games-bar-vertical')
  if games_bar_vertical.length > 0
    jCarouselAutoInit(games_bar_vertical, {
      vertical: true,
      animation: 500,
      scroll: 3
    });

  matches_bar_vertical = $('#matches-bar-vertical')
  if matches_bar_vertical.length > 0
    jCarouselAutoInit(matches_bar_vertical, {
      vertical: true,
      animation: 500,
      scroll: 3
    });

  shop_carousel = $('#shop-carousel')
  if shop_carousel.length > 0
    shop_carousel.jcarousel
      vertical: false
      animation: 500
      scroll: 1

  related_videos_carousel = $('#related-videos-carousel')
  if related_videos_carousel.length > 0
    related_videos_carousel.jcarousel
      vertical: false
      animation: 500
      scroll: 1

  team_rank = $('#team-rank')
  expand_rank = $("a#expand_rank")
  if team_rank.length > 0
    team_rank.change ->
      $('.team-rank-home').hide()
      showRank = $(@).val()
      $('#expand_rank').attr('href', showRank)
      $(showRank).show()
    # expand_rank.click(function(event){});

  expand_rank.fancybox
    'afterClose': ->
      $(team_rank).trigger("change")
    'hideOnContentClick': true

  events_all_page = $('.events-all-page')
  if events_all_page.length > 0
    data_json = $('#carousel-events').data().data_json
    argsCarouselEvents = new Array(3)
    argsCarouselEvents.prevText = data_json.prevText
    argsCarouselEvents.nextText = data_json.nextText
    argsCarouselEvents.todayText = data_json.todayText
    selectedClass = data_json.selectedClass
    normalClass = data_json.normalClass
    carouselEventsAll(data_json.startPoint, argsCarouselEvents)

  contact_page_template = $('.contact-page-template')
  if contact_page_template.length > 0
    $(".contact-page-template-avatarbox").click ->
      contact_id = $(@).data().openbox
      open_box(contact_id) if contact_id

  submit_comment = $('#commentform #submit')
  if submit_comment.length > 0
    $(submit_comment).click ->
      toggleOverlay()

  setTimeout ->
    $(".nav > ul").each ->
      l_position = 0
      el_left = null
      $(@).children().each ->
        if $(@).position().left > l_position
          l_position = $(@).position().left
          el_left = $(@)
      el_left.addClass("add-br-right")
  , 1000

  $('#privacy-policy h3').addClass('box-title')

# Customizer
window.increase_brightness = (hex, percent)->
  hex = hex.replace(/^\s*#|\s*$/g, '')
  hex = hex.replace(/(.)/g, '$1$1') if hex.length == 3

  r = parseInt(hex.substr(0, 2), 16)
  g = parseInt(hex.substr(2, 2), 16)
  b = parseInt(hex.substr(4, 2), 16)

  '#' + ((0|(1<<8) + r + (256 - r) * percent / 100).toString(16)).substr(1) + ((0|(1<<8) + g + (256 - g) * percent / 100).toString(16)).substr(1) + ((0|(1<<8) + b + (256 - b) * percent / 100).toString(16)).substr(1)

$ ->
  window.box_background_color2_backend = (newval) ->
    _final_color = increase_brightness(newval,30)
    _style = ""
    _style = _style + "background: #{newval};"
    _style = _style + "background: -moz-linear-gradient(top,  #{newval} 0%, #{_final_color} 40%);"
    _style = _style + "background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#{newval}), color-stop(40%,#{_final_color}));"
    _style = _style + "background: -webkit-linear-gradient(top,  #{newval} 0%,#{_final_color} 40%);"
    _style = _style + "background: -o-linear-gradient(top,  #{newval} 0%, #{_final_color} 40%);"
    _style = _style + "background: -ms-linear-gradient(top,  #{newval} 0%,#{_final_color} 40%);"
    _style = _style + "background: linear-gradient(top bottom,  #{newval} 0%,#{_final_color} 40%);"
    _style = _style + "filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#{newval}', endColorstr='#{_final_color}',GradientType=0 )"
    return ".dark_button{ #{_style} }"

  if typeof wp != "undefined" and wp.customize
    wp.customize "header", (value) ->
      value.bind (newval) ->
        $("#header").attr 'style', "background-image: url(#{newval})!important;"